<template>
  <div  id="extra-tip" v-html="extra">
  </div>
</template>
<script>
export default {
  name: 'ExtraTip',
  data () {

  },
  props: ['extra']
}
</script>
<style scoped>
 div {
   white-space: pre-line;
   padding-right: 20px;
   padding-left: 10px;
 }
</style>



// WEBPACK FOOTER //
// src/components/products_extra_tip.vue